import { Button } from '@mui/material'
import React from 'react'
import { StyledTextField } from '../../../../styles/common/UIComponents'
import { FlexContainer } from '../../../../styles/common/FlexBox'

const Assefaz = () => {
  return (
    <FlexContainer direction="column" justify="center" align="center" margin="0 0 1rem 0" gap="1.5rem" >
        <StyledTextField id="outlined-basic" label="CPF" variant="outlined"/>
        <Button variant="outlined">Entrar</Button>
    </FlexContainer>
  )
}

export default Assefaz